import { render, staticRenderFns } from "./ChecklistHistory.vue?vue&type=template&id=6c06910b"
import script from "./ChecklistHistory.vue?vue&type=script&lang=js"
export * from "./ChecklistHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports